import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import { AiFillGithub, AiFillMail } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { ImLocation2 } from "react-icons/im";

function Contact() {
  return (
    <section id="contact">
      <Container fluid style={{ height: "90vh" }}>
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={12} className="home-about-social">
              <h1 className="project-heading">
                Contact <strong className="purple">ME </strong>
              </h1>
              <p>
                Feel free to <span className="purple">connect </span>with me
              </p>
              <ul className="home-about-social-links">
                <li className="social-icons">
                  <a
                    href="https://github.com/VishalBhuse"
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour  home-social-icons"
                  >
                    <AiFillGithub />
                  </a>
                </li>
                <li className="social-icons">
                  <a
                    href="https://www.linkedin.com/in/vishal-bhuse-005a28293/"
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour  home-social-icons"
                  >
                    <FaLinkedinIn />
                  </a>
                </li>
                <li className="social-icons">
                  <a
                    href="mailto:vbhuse2407@gmail.com"
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour  home-social-icons"
                  >
                    <AiFillMail />
                  </a>
                </li>
              </ul>
            </Col>
          </Row>
          <Row>
            <Col md={12} className="home-about-social ">
              <a
                href="https://goo.gl/maps/ABsAwscpsDarKLNg6"
                target="_blank"
                rel="noreferrer"
                className="icon-colour  home-social-icons"
              >
                <ImLocation2 />
              </a>
              <br />
              <br />
              <span className="purple">Ahmednagar, Maharashtra </span>
            </Col>
          </Row>
        </Container>
      </Container>
    </section>
  );
}

export default Contact;
